/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { BridgeResponseCallback, OpenFinanceOptions, OpenNewWebViewOptions } from '../../types';

/**
 * 打开pdf
 * @param url
 */
export const openPdf = (url: string): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openPdf', 'openPdf');
    return;
  }

  bridgeCallHandler('openPdf', url, null);
};

/**
 * 打开新的webview
 * @param data
 * @returns
 */
export const openWebviewUrl = (data: OpenNewWebViewOptions): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    window.location.href = data.url;
    return;
  }

  const params: string = JSON.stringify(data);
  bridgeCallHandler('openWebUrl', params, null);
};

/**
 * 调用客户端打开资金页面
 * @param data
 * @returns
 */
export const openFiancePage = (data: OpenFinanceOptions): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openFiancePage', 'openFiancePage');
    return;
  }

  const params: string = JSON.stringify(data);
  bridgeCallHandler('openFiancePage', params, null);
};

/**
 * 打开外部链接
 * @param url
 * @returns
 */
export const openExternalLink = (url: string): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    window.open(url);
    return;
  }
  bridgeCallHandler('openExternalLink', url, null);
};

/**
 * 打开功能页面
 * @param type 0原生，1内嵌h5
 * @param url 功能页面url
 * @param isClose 跳转原生界面时候，点击返回是否关闭原生界面 0不关闭，1关闭 --2025.08.07 新增 3.0.9版本支持
 * @param callback 回调函数
 */
export const explanationToFunctionPage = (
  type: string,
  url: string,
  isClose: string = '0',
  callback: BridgeResponseCallback | null = null,
): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('explanationToFunctionPage', 'jumpFunction');
    return;
  }
  bridgeCallHandler('jumpFunction', JSON.stringify({ type, url, isClose }), callback);
};
